/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: src/proto/api.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as src_proto_api_pb from '../../src/proto/api_pb';


export class GatewayPublicClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorSubmitCognitoCodeGrant = new grpcWeb.MethodDescriptor(
    '/api.GatewayPublic/SubmitCognitoCodeGrant',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.SubmitCognitoCodeGrantRequest,
    src_proto_api_pb.SubmitCognitoCodeGrantResponse,
    (request: src_proto_api_pb.SubmitCognitoCodeGrantRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.SubmitCognitoCodeGrantResponse.deserializeBinary
  );

  submitCognitoCodeGrant(
    request: src_proto_api_pb.SubmitCognitoCodeGrantRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.SubmitCognitoCodeGrantResponse>;

  submitCognitoCodeGrant(
    request: src_proto_api_pb.SubmitCognitoCodeGrantRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.SubmitCognitoCodeGrantResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.SubmitCognitoCodeGrantResponse>;

  submitCognitoCodeGrant(
    request: src_proto_api_pb.SubmitCognitoCodeGrantRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.SubmitCognitoCodeGrantResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.GatewayPublic/SubmitCognitoCodeGrant',
        request,
        metadata || {},
        this.methodDescriptorSubmitCognitoCodeGrant,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.GatewayPublic/SubmitCognitoCodeGrant',
    request,
    metadata || {},
    this.methodDescriptorSubmitCognitoCodeGrant);
  }

}

export class GatewayAdminClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreateChain = new grpcWeb.MethodDescriptor(
    '/api.GatewayAdmin/CreateChain',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.CreateChainRequest,
    src_proto_api_pb.CreateChainResponse,
    (request: src_proto_api_pb.CreateChainRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.CreateChainResponse.deserializeBinary
  );

  createChain(
    request: src_proto_api_pb.CreateChainRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.CreateChainResponse>;

  createChain(
    request: src_proto_api_pb.CreateChainRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.CreateChainResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.CreateChainResponse>;

  createChain(
    request: src_proto_api_pb.CreateChainRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.CreateChainResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.GatewayAdmin/CreateChain',
        request,
        metadata || {},
        this.methodDescriptorCreateChain,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.GatewayAdmin/CreateChain',
    request,
    metadata || {},
    this.methodDescriptorCreateChain);
  }

  methodDescriptorUpdateChain = new grpcWeb.MethodDescriptor(
    '/api.GatewayAdmin/UpdateChain',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.UpdateChainRequest,
    src_proto_api_pb.UpdateChainResponse,
    (request: src_proto_api_pb.UpdateChainRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.UpdateChainResponse.deserializeBinary
  );

  updateChain(
    request: src_proto_api_pb.UpdateChainRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.UpdateChainResponse>;

  updateChain(
    request: src_proto_api_pb.UpdateChainRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.UpdateChainResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.UpdateChainResponse>;

  updateChain(
    request: src_proto_api_pb.UpdateChainRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.UpdateChainResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.GatewayAdmin/UpdateChain',
        request,
        metadata || {},
        this.methodDescriptorUpdateChain,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.GatewayAdmin/UpdateChain',
    request,
    metadata || {},
    this.methodDescriptorUpdateChain);
  }

}

export class GatewayClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorInitiateDestinationRegistration = new grpcWeb.MethodDescriptor(
    '/api.Gateway/InitiateDestinationRegistration',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.InitiateDestinationRegistrationRequest,
    src_proto_api_pb.InitiateDestinationRegistrationResponse,
    (request: src_proto_api_pb.InitiateDestinationRegistrationRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.InitiateDestinationRegistrationResponse.deserializeBinary
  );

  initiateDestinationRegistration(
    request: src_proto_api_pb.InitiateDestinationRegistrationRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.InitiateDestinationRegistrationResponse>;

  initiateDestinationRegistration(
    request: src_proto_api_pb.InitiateDestinationRegistrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.InitiateDestinationRegistrationResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.InitiateDestinationRegistrationResponse>;

  initiateDestinationRegistration(
    request: src_proto_api_pb.InitiateDestinationRegistrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.InitiateDestinationRegistrationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/InitiateDestinationRegistration',
        request,
        metadata || {},
        this.methodDescriptorInitiateDestinationRegistration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/InitiateDestinationRegistration',
    request,
    metadata || {},
    this.methodDescriptorInitiateDestinationRegistration);
  }

  methodDescriptorConfirmDestinationRegistration = new grpcWeb.MethodDescriptor(
    '/api.Gateway/ConfirmDestinationRegistration',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.ConfirmDestinationRegistrationRequest,
    src_proto_api_pb.ConfirmDestinationRegistrationResponse,
    (request: src_proto_api_pb.ConfirmDestinationRegistrationRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.ConfirmDestinationRegistrationResponse.deserializeBinary
  );

  confirmDestinationRegistration(
    request: src_proto_api_pb.ConfirmDestinationRegistrationRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.ConfirmDestinationRegistrationResponse>;

  confirmDestinationRegistration(
    request: src_proto_api_pb.ConfirmDestinationRegistrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.ConfirmDestinationRegistrationResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.ConfirmDestinationRegistrationResponse>;

  confirmDestinationRegistration(
    request: src_proto_api_pb.ConfirmDestinationRegistrationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.ConfirmDestinationRegistrationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/ConfirmDestinationRegistration',
        request,
        metadata || {},
        this.methodDescriptorConfirmDestinationRegistration,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/ConfirmDestinationRegistration',
    request,
    metadata || {},
    this.methodDescriptorConfirmDestinationRegistration);
  }

  methodDescriptorGetUserDestinations = new grpcWeb.MethodDescriptor(
    '/api.Gateway/GetUserDestinations',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.GetUserDestinationsRequest,
    src_proto_api_pb.GetUserDestinationsResponse,
    (request: src_proto_api_pb.GetUserDestinationsRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.GetUserDestinationsResponse.deserializeBinary
  );

  getUserDestinations(
    request: src_proto_api_pb.GetUserDestinationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.GetUserDestinationsResponse>;

  getUserDestinations(
    request: src_proto_api_pb.GetUserDestinationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetUserDestinationsResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.GetUserDestinationsResponse>;

  getUserDestinations(
    request: src_proto_api_pb.GetUserDestinationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetUserDestinationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/GetUserDestinations',
        request,
        metadata || {},
        this.methodDescriptorGetUserDestinations,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/GetUserDestinations',
    request,
    metadata || {},
    this.methodDescriptorGetUserDestinations);
  }

  methodDescriptorUpdateUserDestination = new grpcWeb.MethodDescriptor(
    '/api.Gateway/UpdateUserDestination',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.UpdateUserDestinationRequest,
    src_proto_api_pb.UpdateUserDestinationResponse,
    (request: src_proto_api_pb.UpdateUserDestinationRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.UpdateUserDestinationResponse.deserializeBinary
  );

  updateUserDestination(
    request: src_proto_api_pb.UpdateUserDestinationRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.UpdateUserDestinationResponse>;

  updateUserDestination(
    request: src_proto_api_pb.UpdateUserDestinationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.UpdateUserDestinationResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.UpdateUserDestinationResponse>;

  updateUserDestination(
    request: src_proto_api_pb.UpdateUserDestinationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.UpdateUserDestinationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/UpdateUserDestination',
        request,
        metadata || {},
        this.methodDescriptorUpdateUserDestination,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/UpdateUserDestination',
    request,
    metadata || {},
    this.methodDescriptorUpdateUserDestination);
  }

  methodDescriptorDeleteUserDestination = new grpcWeb.MethodDescriptor(
    '/api.Gateway/DeleteUserDestination',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.DeleteUserDestinationRequest,
    src_proto_api_pb.DeleteUserDestinationResponse,
    (request: src_proto_api_pb.DeleteUserDestinationRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.DeleteUserDestinationResponse.deserializeBinary
  );

  deleteUserDestination(
    request: src_proto_api_pb.DeleteUserDestinationRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.DeleteUserDestinationResponse>;

  deleteUserDestination(
    request: src_proto_api_pb.DeleteUserDestinationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.DeleteUserDestinationResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.DeleteUserDestinationResponse>;

  deleteUserDestination(
    request: src_proto_api_pb.DeleteUserDestinationRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.DeleteUserDestinationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/DeleteUserDestination',
        request,
        metadata || {},
        this.methodDescriptorDeleteUserDestination,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/DeleteUserDestination',
    request,
    metadata || {},
    this.methodDescriptorDeleteUserDestination);
  }

  methodDescriptorCreateAlert = new grpcWeb.MethodDescriptor(
    '/api.Gateway/CreateAlert',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.CreateAlertRequest,
    src_proto_api_pb.CreateAlertResponse,
    (request: src_proto_api_pb.CreateAlertRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.CreateAlertResponse.deserializeBinary
  );

  createAlert(
    request: src_proto_api_pb.CreateAlertRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.CreateAlertResponse>;

  createAlert(
    request: src_proto_api_pb.CreateAlertRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.CreateAlertResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.CreateAlertResponse>;

  createAlert(
    request: src_proto_api_pb.CreateAlertRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.CreateAlertResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/CreateAlert',
        request,
        metadata || {},
        this.methodDescriptorCreateAlert,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/CreateAlert',
    request,
    metadata || {},
    this.methodDescriptorCreateAlert);
  }

  methodDescriptorGetAlerts = new grpcWeb.MethodDescriptor(
    '/api.Gateway/GetAlerts',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.GetAlertsRequest,
    src_proto_api_pb.GetAlertsResponse,
    (request: src_proto_api_pb.GetAlertsRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.GetAlertsResponse.deserializeBinary
  );

  getAlerts(
    request: src_proto_api_pb.GetAlertsRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.GetAlertsResponse>;

  getAlerts(
    request: src_proto_api_pb.GetAlertsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetAlertsResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.GetAlertsResponse>;

  getAlerts(
    request: src_proto_api_pb.GetAlertsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetAlertsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/GetAlerts',
        request,
        metadata || {},
        this.methodDescriptorGetAlerts,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/GetAlerts',
    request,
    metadata || {},
    this.methodDescriptorGetAlerts);
  }

  methodDescriptorUpdateAlert = new grpcWeb.MethodDescriptor(
    '/api.Gateway/UpdateAlert',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.UpdateAlertRequest,
    src_proto_api_pb.UpdateAlertResponse,
    (request: src_proto_api_pb.UpdateAlertRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.UpdateAlertResponse.deserializeBinary
  );

  updateAlert(
    request: src_proto_api_pb.UpdateAlertRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.UpdateAlertResponse>;

  updateAlert(
    request: src_proto_api_pb.UpdateAlertRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.UpdateAlertResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.UpdateAlertResponse>;

  updateAlert(
    request: src_proto_api_pb.UpdateAlertRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.UpdateAlertResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/UpdateAlert',
        request,
        metadata || {},
        this.methodDescriptorUpdateAlert,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/UpdateAlert',
    request,
    metadata || {},
    this.methodDescriptorUpdateAlert);
  }

  methodDescriptorDeleteAlert = new grpcWeb.MethodDescriptor(
    '/api.Gateway/DeleteAlert',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.DeleteAlertRequest,
    src_proto_api_pb.DeleteAlertResponse,
    (request: src_proto_api_pb.DeleteAlertRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.DeleteAlertResponse.deserializeBinary
  );

  deleteAlert(
    request: src_proto_api_pb.DeleteAlertRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.DeleteAlertResponse>;

  deleteAlert(
    request: src_proto_api_pb.DeleteAlertRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.DeleteAlertResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.DeleteAlertResponse>;

  deleteAlert(
    request: src_proto_api_pb.DeleteAlertRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.DeleteAlertResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/DeleteAlert',
        request,
        metadata || {},
        this.methodDescriptorDeleteAlert,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/DeleteAlert',
    request,
    metadata || {},
    this.methodDescriptorDeleteAlert);
  }

  methodDescriptorGetNotifications = new grpcWeb.MethodDescriptor(
    '/api.Gateway/GetNotifications',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.GetNotificationsRequest,
    src_proto_api_pb.GetNotificationsResponse,
    (request: src_proto_api_pb.GetNotificationsRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.GetNotificationsResponse.deserializeBinary
  );

  getNotifications(
    request: src_proto_api_pb.GetNotificationsRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.GetNotificationsResponse>;

  getNotifications(
    request: src_proto_api_pb.GetNotificationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetNotificationsResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.GetNotificationsResponse>;

  getNotifications(
    request: src_proto_api_pb.GetNotificationsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetNotificationsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/GetNotifications',
        request,
        metadata || {},
        this.methodDescriptorGetNotifications,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/GetNotifications',
    request,
    metadata || {},
    this.methodDescriptorGetNotifications);
  }

  methodDescriptorGetChains = new grpcWeb.MethodDescriptor(
    '/api.Gateway/GetChains',
    grpcWeb.MethodType.UNARY,
    src_proto_api_pb.GetChainsRequest,
    src_proto_api_pb.GetChainsResponse,
    (request: src_proto_api_pb.GetChainsRequest) => {
      return request.serializeBinary();
    },
    src_proto_api_pb.GetChainsResponse.deserializeBinary
  );

  getChains(
    request: src_proto_api_pb.GetChainsRequest,
    metadata: grpcWeb.Metadata | null): Promise<src_proto_api_pb.GetChainsResponse>;

  getChains(
    request: src_proto_api_pb.GetChainsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetChainsResponse) => void): grpcWeb.ClientReadableStream<src_proto_api_pb.GetChainsResponse>;

  getChains(
    request: src_proto_api_pb.GetChainsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: src_proto_api_pb.GetChainsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.Gateway/GetChains',
        request,
        metadata || {},
        this.methodDescriptorGetChains,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.Gateway/GetChains',
    request,
    metadata || {},
    this.methodDescriptorGetChains);
  }

}

